import React from "react";

import MainLayout from "../../components/MainLayout";
import Cards from "./containers/Cards";

import { getDomainWithLanguageURL } from "../../utils/languageFunctions";

const ArchivePage = () => {

    // Si el párametro indica que esta en español, entonces pasar el siguiente link con dicho parametro
    // para que tambièn este en español.

    return <MainLayout>
        <Cards className="sm:grid-cols-4 grid-cols-3 max-w-6xl" urlPart={getDomainWithLanguageURL()} />
    </MainLayout>
}; 

export default ArchivePage; 